import EditTaskPanelContainer from './user/components/EditTaskPanelContainer'
import CreateTasksPopupController from './addNewTasks/CreateTasksPopupController'
import {unsafe_bindActions, unsafe_selectWithState} from './redux/utils'
import {bindActionCreators} from 'redux'
import {supportPopupPositionStrategy} from './support/supportForm/constants'
import {openEditTaskPanel} from './panels/task/editPanel/actions'
import {openSupportForm} from './support/supportForm/actions'
import {getLoggedInUser} from './loggedInUser/selectors'
import {currentUsedUserCount} from './activeLicenseInfo/selectors'
import {setEventPreventHidingEditTaskSlidingPanel} from './panels/utils'

class NextBridge {
    listeners = {
        taskPanelClosed: [],
        tasksCreated: [],
        taskDeleted: [],
        taskMoved: [],
        profileSettingsChanged: []
    }

    basePath = window.BASE_PATH

    GlobalConstants = window.__GENERATED_CONSTANTS__
    SystemSettings = window.SystemSettings

    stripeJsAuthKey = window.StripeConfig.KEY

    _init() {
        this.actions = unsafe_bindActions((dispatch) => ({
            openSupportForm: bindActionCreators(openSupportForm, dispatch),
            openEditTaskPanel: bindActionCreators(openEditTaskPanel, dispatch),
        }))

        $(document).on('close_user_profile_event', () => {
            this.listeners.profileSettingsChanged.forEach(handler => handler())
        })
    }

    /**
     * Get logged in user from classic store
     */
    getMe() {
        return unsafe_selectWithState(state => getLoggedInUser(state))
    }

    /**
     * Init components necessary for enterTT
     */
    initEnterTT() {
        this._init()
        this.initTaskPanel()
        this.initNewTaskPopup()
    }

    initLicenses() {
        this._init()
    }

    initTaskPanel() {
        this.editTaskPanelContainer = new EditTaskPanelContainer({
            onTaskDeletedCb: (taskId) => this.listeners.taskDeleted.forEach(handler => handler(taskId)),
            onTaskMovedCb: taskId => this.listeners.taskMoved.forEach(handler => handler(taskId)),
        })
        this.editTaskPanelContainer.init()
        this.editTaskPanelContainer.onStatePropertyBecameValue('isShown', false, isShown =>
            this.listeners.taskPanelClosed.forEach(handler => handler()))
    }

    initNewTaskPopup() {
        this.createTasksPopupController = new CreateTasksPopupController({
            successTaskCreationCb: (result) => this.listeners.tasksCreated.forEach(handler => handler(result)),
            serviceName: "AddNewTasksService"
        })
    }

    /**
     * Open side task panel for specified taskId
     * @param taskId - classic task id
     * @param event - mouse event that caused the action
     */
    openTaskPanel(taskId, event) {
        setEventPreventHidingEditTaskSlidingPanel($.Event(event))
        this.actions.openEditTaskPanel(taskId)
    }

    /**
     * Open new task popup for specified user and dayOnWeek
     * @param selectedUserId
     * @param submitTtDate
     */
    openNewTaskPopup(selectedUserId, submitTtDate) {
        this.createTasksPopupController.showPopup(null, null, selectedUserId, false, submitTtDate)
    }

    getLicensesData() {
        return {
            currentUsedUserCount: unsafe_selectWithState(state => currentUsedUserCount(state))
        }
    }

    /**
     * Subscribe to classic interface events.
     * - taskPanelClosed
     * - tasksCreated
     * - taskDeleted
     * - taskMoved
     * @param handlers - list of handlers in {[key:string] : handler: (data: any) => void}
     */
    subscribeToEvent(handlers) {
        Object.keys(handlers).forEach(name => {
            const handler = handlers[name]
            if (!this.listeners[name]) throw new Error("Invalid event name " + name)
            if (!this.listeners[name].find(h => h === handler))
                this.listeners[name].push(handler)
        })
    }

    /**
     * Open support form
     * @param positionParams - forms positioning params:
     *  positionStrategy can take the values: 'center', 'fromTopLeft', 'fromBottomRight'
     *  position takes the coordinates
     */
    openSupportForm(positionParams = {
        positionStrategy: supportPopupPositionStrategy.CENTER,
        position: {x: 0, y: 0,},
    }) {
        this.actions.openSupportForm(positionParams)
    }

    /**
     * Opens user profile settings popup (profile.do)
     */
    openProfileSettingsPopup (highlightStartingNewWeekSection = false) {
        $(document).trigger('open_user_profile_event', [highlightStartingNewWeekSection])
    }
}

const nextBridge = new NextBridge()
export default nextBridge



// WEBPACK FOOTER //
// ./web/js/NextBridge.js